import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { forwardRef, useContext, useEffect, useImperativeHandle, useState } from 'react';
import CustomSelect2 from './CustomSelect2';
import { Box, Typography, FormControlLabel, Checkbox, Grid, TextField, InputAdornment, Select, MenuItem, colors, Button } from '@mui/material';
import SelectPlanCheckbox from './SelectPlanCheckbox';
import { ConfigContext } from '../utils/ConfigContext';
import { AuthContext } from '../utils/AuthContext';
import TableRatesRow from './TableRatesRow';
import { getQuotation } from '../services/CompanyQuotationService';
import getSafe from '../utils/getSafe';
import domtoimage from 'dom-to-image';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PercentInput from './PercentInput';
import NotesDisplay from './NotesDisplay';
import RatesVersionSelect from './RatesVersionSelect';
import CopyImageButton from './CopyImageButton';
import CopyExcelDataButton from './CopyExcelDataButton';
import { set } from 'lodash';


const OptimumGlobal_Rates = forwardRef(({ appConfig, sx, clients, loadingStatus, currency, selectedPlans, setSelectedPlans,
  response, deductibles, setDeductibles, addToPendingTasks,
  discounts, setDiscounts, computedRates, setComputedRates,
  specificAreaOfCoverage, setSpecificAreaOfCoverage, areaOfCoverage,
  setShowImageCopy, selectedOptions, addSelectedOption,
  setViewSelectedOption, specificCurrency, setSpecificCurrency,
  specificPaymentFrequency, setSpecificPaymentFrequency,
  optimumGlobalSpecific, setOptimumGlobalSpecific, additionalLoadings, setAdditionalLoadings,
  setHasTOBDataChanged , insurerRates = [], selectedRatesVersion, setSelectedRatesVersion, handleFetchAppConfig, setShowRefreshNow }, ref) => {
  // const { appConfig } = useContext(ConfigContext);

  const id = 'optimum_global';

  const mhd_group_loadings = getSafe(() => appConfig.content.specifics.optimum_global.mhd_group_loadings);
  const business_types = getSafe(() => appConfig.content.specifics.optimum_global.business_type);
  const quote_types = getSafe(() => appConfig.content.specifics.optimum_global.quote_type);
  const family_discounts = getSafe(() => appConfig.content.specifics.optimum_global.family_discount);
  const bmi_loadings = getSafe(() => appConfig.content.specifics.optimum_global.bmi_loadings);
  const out_patient_co_pay = getSafe(() => appConfig.content.specifics.optimum_global.out_patient_co_pay);
  const area_of_cover = getSafe(() => appConfig.content.specifics.optimum_global.area_of_cover);
  const in_patient_deductible = getSafe(() => appConfig.content.specifics.optimum_global.in_patient_deductible);
  const optimum_global_deductibles = getSafe(() => appConfig.content.deductibles.optimum_global, []);
  const payment_terms = getSafe(() => appConfig.content.specifics.optimum_global.payment_terms);
  const currency_rates = getSafe(() => appConfig.content.specifics.optimum_global.currency_rates);


  const [businessType, setBusinessType] = useState(getBusinessTypesLabel().length > 0 ? getBusinessTypesLabel()[0] : '');
  const [quoteType, setQuoteType] = useState(quote_types ? quote_types[0] : '');
  const [MHD_Group_Loading, set_MHD_Group_Loading] = useState(mhd_group_loadings ? get_MHD_Group_LoadingsLabel()[0] : '');
  const [familyDiscount, setFamilyDiscount] = useState(family_discounts ? getFamilyDiscountsLabel()[0] : '');
  const [bmiLoading, setBmiLoading] = useState(bmi_loadings ? getBmiLoadingsLabel()[0] : '');
  const [outpatientCoPay, setOutpatientCoPay] = useState(out_patient_co_pay ? getOutpatientCoPayLabels()[0] : '');


  const company_Plans = ['optimum_global_emerald', 'optimum_global_sapphire', 'optimum_global_ruby', 'optimum_global_jade', 'optimum_global_diamond'];

  const specific_area_of_coverages = getSafe(() => appConfig.content.optimum_global_area_of_coverage, []);

  const currencies = getSafe(() => appConfig.content.currencies, []);

  const [addOns, setAddOns] = useState({
    dental: false,
    maternity: false,
    optical: false,
  });


  const [addOnsPerClient, setAddOnsPerClient] = useState({});

  // const [assistanceCovers, setAssistanceCovers] = useState({
  //   evacuation: false,
  //   repatriation: false,
  // });

  useEffect(() => {
    computedRates[id] = getComputedRates();
    setComputedRates(computedRates);

    setHasTOBDataChanged(true);
  }, [response, discounts, businessType, quoteType, familyDiscount, MHD_Group_Loading, bmiLoading, outpatientCoPay, deductibles[id], additionalLoadings, addOns.dental, addOns.maternity, addOns.optical]);

  useEffect(() => {
    // if (businessType === 'Individual') {
    //   set_MHD_Group_Loading('N/A');
    // }

    if (businessType !== 'Individual') {
      setFamilyDiscount('N/A');
    }

  }, [businessType]);

  useEffect(() => {
    setTimeout(() => {
      addSelectedOption(id, 'business_type', businessType);
      addSelectedOption(id, 'quote_type', quoteType);
      addSelectedOption(id, 'mhd_group_loading', MHD_Group_Loading);
      addSelectedOption(id, 'family_discount', familyDiscount);
      addSelectedOption(id, 'bmi_loadings', bmiLoading);
      addSelectedOption(id, 'outpatient_co_pay', outpatientCoPay);
      addSelectedOption(id, 'add_ons_per_client', JSON.stringify(addOnsPerClient));
      addSelectedOption(id, 'add_ons', JSON.stringify(addOns));

      addSelectedOption(id, 'specific_area_of_coverage', specificAreaOfCoverage[id]);
      addSelectedOption(id, 'specific_currency', specificCurrency[id]);
      addSelectedOption(id, 'specific_payment_frequency', specificPaymentFrequency[id]);
      addSelectedOption(id, 'deductible', deductibles[id]);
      addSelectedOption(id, 'discount', discounts[id] == '' ? 0 : discounts[id]);
      addSelectedOption(id, 'loading', additionalLoadings[id] == '' ? 0 : additionalLoadings[id]);
    }, 1000);
  }, [JSON.stringify(addOnsPerClient), JSON.stringify(addOns), businessType, quoteType, familyDiscount, MHD_Group_Loading,
    bmiLoading, outpatientCoPay, specificAreaOfCoverage[id], specificCurrency[id], specificPaymentFrequency[id], deductibles[id], discounts[id], additionalLoadings[id]]);

  useEffect(() => {
    setViewSelectedOption(id, 'business_type', setBusinessType);
    setViewSelectedOption(id, 'quote_type', setQuoteType);
    setViewSelectedOption(id, 'mhd_group_loading', set_MHD_Group_Loading);
    setViewSelectedOption(id, 'family_discount', setFamilyDiscount);
    setViewSelectedOption(id, 'bmi_loadings', setBmiLoading);
    setViewSelectedOption(id, 'outpatient_co_pay', setOutpatientCoPay);

    setViewSelectedOption(id, 'business_type', (option_value) => {
      optimumGlobalSpecific['business_type'] = option_value;
      setOptimumGlobalSpecific({ ...optimumGlobalSpecific });
    });

    setViewSelectedOption(id, 'quote_type', (option_value) => {
      optimumGlobalSpecific['quote_type'] = option_value;
      setOptimumGlobalSpecific({ ...optimumGlobalSpecific });
    });

    setViewSelectedOption(id, 'mhd_group_loading', (option_value) => {
      optimumGlobalSpecific['mhd_group_loading'] = option_value;
      setOptimumGlobalSpecific({ ...optimumGlobalSpecific });
    });

    setViewSelectedOption(id, 'family_discount', (option_value) => {
      optimumGlobalSpecific['family_discount'] = option_value;
      setOptimumGlobalSpecific({ ...optimumGlobalSpecific });
    });

    setViewSelectedOption(id, 'bmi_loadings', (option_value) => {
      optimumGlobalSpecific['bmi_loadings'] = option_value;
      setOptimumGlobalSpecific({ ...optimumGlobalSpecific });
    });

    setViewSelectedOption(id, 'outpatient_co_pay', (option_value) => {
      optimumGlobalSpecific['outpatient_co_pay'] = option_value;
      setOptimumGlobalSpecific({ ...optimumGlobalSpecific });
    });

    setViewSelectedOption(id, 'add_ons_per_client', (option_value) => {
      setAddOnsPerClient(JSON.parse(option_value));
    });

    setViewSelectedOption(id, 'add_ons', (option_value) => {
      setAddOns(JSON.parse(option_value));
    });

    setViewSelectedOption(id, 'deductible', (option_value) => {
      deductibles[id] = option_value;
      setDeductibles(deductibles);
    });
    setViewSelectedOption(id, 'discount', (option_value) => {
      discounts[id] = option_value;
      setDiscounts(discounts);
    });

    setViewSelectedOption(id, 'loading', (option_value) => {
      additionalLoadings[id] = option_value;
      setAdditionalLoadings(additionalLoadings);
    });

    setViewSelectedOption(id, 'specific_area_of_coverage', (option_value) => {
      specificAreaOfCoverage[id] = option_value;
      setSpecificAreaOfCoverage(specificAreaOfCoverage);
    });

    setViewSelectedOption(id, 'specific_currency', (option_value) => {
      specificCurrency[id] = option_value;
      setSpecificCurrency(specificCurrency);
    });

    setViewSelectedOption(id, 'specific_payment_frequency', (option_value) => {
      specificPaymentFrequency[id] = option_value;
      setSpecificPaymentFrequency(specificPaymentFrequency);
    });
  }, [selectedOptions]);

  function getComputedRates() {
    if (!response) return;

    const rates = response.rates;
    const discount = discounts[id];
    const loading = parseFloat(additionalLoadings[id]) || 0;
    const totalPercent = (100 - discount + loading) * 0.01;

    const computedRates = [];

    for (let i = 0; i < rates.length; i++) {
      const clientIdx = i;

      computedRates.push({
        'client': rates[i].client,
        'currency': rates[i].currency,
        'emerald': computedRate('emerald', rates[i].emerald, rates[i].client, clientIdx) * totalPercent,
        'sapphire': computedRate('sapphire', rates[i].sapphire, rates[i].client, clientIdx) * totalPercent,
        'ruby': computedRate('ruby', rates[i].ruby, rates[i].client, clientIdx) * totalPercent,
        'jade': computedRate('jade', rates[i].jade, rates[i].client, clientIdx) * totalPercent,
        'diamond': computedRate('diamond', rates[i].diamond, rates[i].client, clientIdx) * totalPercent,
      })
    }

    return computedRates;
  }


  function checkIfThereIsSelected_Company_Plan() {
    for (let i = 0; i < selectedPlans.length; i++) {
      if (company_Plans.includes(selectedPlans[i])) {
        return true;
      }
    }

    return false;
  }

  function getBusinessTypesLabel() {
    const labels = [];

    for (let business_type in business_types) {
      labels.push(business_type);
    }

    return labels;
  }

  function getFamilyDiscountsLabel() {
    const labels = [];

    for (let family_discount in family_discounts) {
      labels.push(family_discount);
    }

    return labels;
  }

  function getBmiLoadingsLabel() {
    const labels = [];

    for (let bmi_loading in bmi_loadings) {
      labels.push(bmi_loading);
    }

    return labels;
  }

  function getOutpatientCoPayLabels() {
    const labels = [];

    for (let co_pay in out_patient_co_pay) {
      labels.push(co_pay);
    }

    return labels;
  }

  function get_MHD_Group_LoadingsLabel() {
    const labels = [];

    for (let mhd_group_loading in mhd_group_loadings) {
      labels.push(mhd_group_loading);
    }

    return labels;
  }

  function computeOptimumGlobalRates(rates) {
    const computedRates = [];

    for (let i = 0; i < rates.length; i++) {
      const clientIdx = i;

      computedRates.push({
        'client': rates[i].client,
        'currency': rates[i].currency,
        'emerald': computedRate('emerald', rates[i].emerald, rates[i].client, clientIdx),
        'sapphire': computedRate('sapphire', rates[i].sapphire, rates[i].client, clientIdx),
        'ruby': computedRate('ruby', rates[i].ruby, rates[i].client, clientIdx),
        'jade': computedRate('jade', rates[i].jade, rates[i].client, clientIdx),
        'diamond': computedRate('diamond', rates[i].diamond, rates[i].client, clientIdx)
      })
    }

    return computedRates;
  }

  function computedRate(plan, rate, client, clientIdx) {
    if (rate === 'Unavailable' || typeof rate === 'string') {
      return rate;
    }

    let total = rate;

    /*
    const currency = specificCurrency[id];

    if (currency === 'SGD') {
      return 'Unavailable';
    }

    const payment_frequency = clients[0]['payment_frequency'];

    if (payment_frequency === 'Monthly') {
      return 'Unavailable';
    }



    const out_patient_co_pay_rate = out_patient_co_pay[outpatientCoPay];
    const deductibleIndex = optimum_global_deductibles[currency].indexOf(deductibles[id]);
    const in_patient_deductible_rate = in_patient_deductible[deductibleIndex];

    const mhd_group_loadings_rate = mhd_group_loadings[MHD_Group_Loading];
    const bmi_loadings_rate = bmi_loadings[bmiLoading];
    const family_discount_rate = family_discounts[familyDiscount];

    const currency_rate = currency_rates[currency];



    const payment_term_rate = payment_terms[payment_frequency];

    let total = rate;

    // only applicable to ruby, jade, and diamond
    if (['ruby', 'jade', 'diamond'].includes(plan)) {
      total = total * out_patient_co_pay_rate;
    }


    total = total * in_patient_deductible_rate;

    total = total + (total * mhd_group_loadings_rate);

    total = total + (total * bmi_loadings_rate);

    total = total * family_discount_rate;

    total = total * currency_rate;

    */



    /*
    if (payment_frequency === 'Semi Annually') {
      total /= 2;
    }

    if (payment_frequency === 'Quarterly') {
      total /= 4;
    }

    total = total * payment_term_rate;
    */

    //optional rates
    if (['emerald', 'sapphire', 'ruby', 'jade', 'diamond'].includes(plan)) {
      const optional_rates = response.optional_rates;

      let dental = optional_rates['dental'][plan];
      let maternity = optional_rates['maternity'][plan];
      let optical = optional_rates['optical'][plan];

      if (addOns.dental && checkAddOnPerClient('dental', clientIdx)) {
        total += dental;
      }

      // Only for Female clients between 18 and 64 years old
      if (addOns.maternity && (client.age >= 18 && client.age <= 64 && client.gender === 'Female') && checkAddOnPerClient('maternity', clientIdx)) {
        total += maternity;
      }

      if (addOns.optical && checkAddOnPerClient('optical', clientIdx)) {
        total += optical;
      }
    }

    return total;
  }

  // function computedRate(plan, rate) {
  //   if (rate === 'Unavailable' || typeof rate === 'string') {
  //     return rate;
  //   }

  //   const MHD_LoadingValue = MHD_Loadings[MHD_Loading];
  //   const companyDiscountValue = companyDiscounts[companyDiscount][plan];
  //   const groupSizeValue = groupSizes[groupSize];

  //   let total = rate;

  //   // MHD loadings
  //   total = total * (1 + MHD_LoadingValue);

  //   // company discount
  //   total = total * (1 - companyDiscountValue);

  //   // group size discount
  //   total = total * (1 - groupSizeValue);

  //   return total;
  // }

  // function getCompanyDiscountLabel(plan) {
  //   const val = companyDiscounts[companyDiscount][plan];

  //   return (val * 100).toFixed(0) + '%'
  // }

  function onInputDiscountChange(e) {
    let value = e.target.value;

    // Allow only numbers and at most one decimal point
    value = value.replace(/[^0-9.]/g, '');

    // Prevent multiple decimals
    if ((value.match(/\./g) || []).length > 1) {
      value = value.substring(0, value.lastIndexOf('.'));
    }

    // Ensure only two decimal places
    if (value.includes('.')) {
      const [integerPart, decimalPart] = value.split('.');
      value = `${integerPart}.${decimalPart.substring(0, 2)}`;
    }

    // Remove leading zeros (but allow "0" or "0.x" scenarios)
    if (value !== '' && value !== '0' && value.startsWith('0') && !value.startsWith('0.')) {
      value = value.replace(/^0+/, '');
    }

    // Limit value to a maximum of 100
    if (parseFloat(value) > 100) {
      value = '100';
    }

    discounts[id] = value;

    setDiscounts({ ...discounts });
  }

  function getAdditionalColumns(plan) {
    if (!response) {

      const placeholder = [];

      if (addOns.dental) {
        placeholder.push({
          value: 'N/A'
        });
      }

      if (addOns.maternity) {
        placeholder.push({
          value: 'N/A'
        });
      }

      if (addOns.optical) {
        placeholder.push({
          value: 'N/A'
        });
      }


      return placeholder;
    }

    let currency;

    if (response.rates.length > 0) {
      currency = response.rates[0].currency;
    } else {
      currency = specificCurrency[id];
    }


    const optional_rates = response.optional_rates;

    let dental = optional_rates['dental'][plan];

    let maternity = optional_rates['maternity'][plan];

    let optical = optional_rates['optical'][plan];


    const columns = [];

    if (addOns.dental) {
      columns.push({ value: dental ? formatOptionalRate(currency, dental) : 'N/A', textAlign: 'center' });
    }

    if (addOns.maternity) {
      columns.push({ value: maternity ? formatOptionalRate(currency, maternity) : 'N/A', textAlign: 'center' });
    }

    if (addOns.optical) {
      columns.push({ value: optical ? formatOptionalRate(currency, optical) : 'N/A', textAlign: 'center' });
    }

    return columns;
  }

  function formatOptionalRate(currency, rate) {
    if (isNaN(rate) || rate == 'Unavailable' || typeof rate === 'string') {
      return <span>{'N/A'}</span>
    }

    if (isNaN(rate)) {
      return rate;
    }

    return getCurrencySign(currency) + rate.toLocaleString('en-PH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function getCurrencySign(currency) {
    // const currency = specificCurrency[id];

    if (currency === 'USD') {
      return '$';
    } else if (currency === 'EURO') {
      return '€';
    } else if (currency === 'GBP') {
      return '£';
    } else if (currency === 'SGD') {
      return 'S$';
    }

    return '';
  }

  function getAreaOfCoverage() {
    if (!area_of_cover) return '';


    let generalAreaOfCoverage = areaOfCoverage;

    if (specificAreaOfCoverage[id] === 'parent') {
      generalAreaOfCoverage = areaOfCoverage;
    } else {
      generalAreaOfCoverage = specificAreaOfCoverage[id];
    }

    const specificArea = area_of_cover[generalAreaOfCoverage] || '';

    return specificArea;
  }


  function checkAddOnPerClient(addon, clientIdx) {
    const isChecked = addOnsPerClient[clientIdx]?.[addon];
    const client = clients[clientIdx];

    if (addon === 'maternity') {
      if (isChecked === undefined) {
        if (client.gender === 'Female' && client.age >= 18 && client.age <= 64) {
          return true;
        } else {
          return false;
        }
      } else {
        return isChecked;
      }

    } else if (addon === 'dental' || addon === 'optical') {
      if (isChecked === undefined) {
        return true;
      } else {
        return isChecked;
      }
    }

    return false;
  }

  function handleAddOnPerClientChange(addon, clientIdx) {
    const prevState = checkAddOnPerClient(addon, clientIdx);

    setAddOnsPerClient((prev) => ({
      ...prev,
      [clientIdx]: {
        ...prev[clientIdx],
        [addon]: !prevState,
      },
    }));
  }

  return (
    <Box id={id} sx={sx}>
      <Paper sx={{ borderColor: '#e0e0e0', borderWidth: 2, pb: 2 }} variant='outlined' >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#009999', px: 2, py: 1 }}>
          <div style={{
            color: '#009999',
            backgroundColor: '#fff',
            width: 100,
            height: 60,
            padding: 6,
            fontFamily: 'Poppins, sans-serif',
            fontSize: 13,
            lineHeight: 1.2,
          }}>Optimum Global</div>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <img src={`${process.env.PUBLIC_URL}/images/Optimum Global Logo.png`} alt="Optimum Global" style={{ height: 60, userSelect: 'none', WebkitUserDrag: 'none' }} draggable={false} onContextMenu={(e) => e.preventDefault()} />
          </Box>
        </Box>

        <Box sx={{ p: 2 }}>

          <Box sx={{ display: 'flex', gap: 5 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={15} fontWeight={600}>Plan Type</Typography>
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='optimum_global_emerald' />} label="Emerald" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='optimum_global_sapphire' />} label="Sapphire" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='optimum_global_ruby' />} label="Ruby" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='optimum_global_jade' />} label="Jade" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='optimum_global_diamond' />} label="Diamond" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={15} fontWeight={600}>Add ons</Typography>
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<Checkbox size="small" checked={addOns.dental}
                onChange={(e) => { setAddOns({ ...addOns, dental: e.target.checked }) }} />}
                label="Dental" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<Checkbox size="small" checked={addOns.maternity}
                onChange={(e) => { setAddOns({ ...addOns, maternity: e.target.checked }) }} />}
                label="Maternity" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<Checkbox size="small" checked={addOns.optical}
                onChange={(e) => { setAddOns({ ...addOns, optical: e.target.checked }) }} />}
                label="Optical" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Business Type</Typography>
                <CustomSelect2
                  dense
                  sx={{ minWidth: 170 }}
                  value={businessType}
                  onChange={(e) => {
                    setBusinessType(e.target.value);

                    optimumGlobalSpecific['business_type'] = e.target.value;
                    setOptimumGlobalSpecific(optimumGlobalSpecific);

                    addToPendingTasks([id]);
                  }}
                  items={getBusinessTypesLabel()}
                  disabled={loadingStatus[id]}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Quote Type</Typography>
                <CustomSelect2
                  dense
                  sx={{ minWidth: 170 }}
                  value={quoteType}
                  onChange={(e) => {
                    setQuoteType(e.target.value);

                    optimumGlobalSpecific['quote_type'] = e.target.value;
                    setOptimumGlobalSpecific(optimumGlobalSpecific);

                    addToPendingTasks([id]);
                  }}
                  items={quote_types}
                  disabled={loadingStatus[id]}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Family Discount</Typography>
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <CustomSelect2
                      dense
                      sx={{ minWidth: 170 }}
                      value={familyDiscount}
                      onChange={(e) => {
                        setFamilyDiscount(e.target.value);

                        optimumGlobalSpecific['family_discount'] = e.target.value;
                        setOptimumGlobalSpecific(optimumGlobalSpecific);

                        addToPendingTasks([id]);
                      }}
                      items={getFamilyDiscountsLabel()}
                      disabled={loadingStatus[id]}
                    />
                    <Typography fontSize={13}>
                      <span display='inline-block' style={{ fontSize: 13, color: '#009999', fontWeight: 600 }}>{family_discounts ? (100 - (family_discounts[familyDiscount] * 100)) : 0}%</span>
                    </Typography>
                  </Box>
                  {familyDiscount === 'Family of 3 or more' && clients.length < 3 && (
                    <Typography fontSize={11} color="#f44336" sx={{ mt: 0.5 }}>
                      Applicable only for 3 or more clients
                    </Typography>
                  )}
                </Box>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Underwriting</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <CustomSelect2
                    dense
                    sx={{ minWidth: 170 }}
                    value={MHD_Group_Loading}
                    onChange={(e) => {
                      set_MHD_Group_Loading(e.target.value);

                      optimumGlobalSpecific['mhd_group_loading'] = e.target.value;
                      setOptimumGlobalSpecific(optimumGlobalSpecific);

                      addToPendingTasks([id]);
                    }}
                    items={get_MHD_Group_LoadingsLabel()}
                    disabled={loadingStatus[id]}
                  />
                  <Typography fontSize={13}>
                    <span display='inline-block' style={{ fontSize: 13, color: '#009999', fontWeight: 600 }}>{mhd_group_loadings ? mhd_group_loadings[MHD_Group_Loading] * 100 : 0}%</span>
                  </Typography>
                </Box>
              </Box>


              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>BMI Loadings</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <CustomSelect2
                    dense
                    sx={{ minWidth: 170 }}
                    value={bmiLoading}
                    onChange={(e) => {
                      setBmiLoading(e.target.value);

                      optimumGlobalSpecific['bmi_loading'] = e.target.value;
                      setOptimumGlobalSpecific(optimumGlobalSpecific);

                      addToPendingTasks([id]);
                    }}
                    items={getBmiLoadingsLabel()}
                    disabled={loadingStatus[id]}
                  />
                  <Typography fontSize={13}>
                    <span display='inline-block' style={{ fontSize: 13, color: '#009999', fontWeight: 600 }}>{bmi_loadings ? (bmi_loadings[bmiLoading] * 100) : 0}%</span>
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Area of Coverage</Typography>
                <Select
                  size='small'
                  value={specificAreaOfCoverage[id]}
                  onChange={(e) => {
                    specificAreaOfCoverage[id] = e.target.value;
                    setSpecificAreaOfCoverage({ ...specificAreaOfCoverage });

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px' }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {/* <MenuItem value={'parent'} sx={{ color: colors.blue[500] }}>{areaOfCoverage}</MenuItem> */}
                  {
                    specific_area_of_coverages && specific_area_of_coverages.map(area_of_coverage => (
                      <MenuItem key={area_of_coverage} value={area_of_coverage} sx={{ fontSize: 12 }}>{area_of_coverage}</MenuItem>
                    ))
                  }

                </Select>


              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Currency</Typography>
                <Select
                  size='small'
                  value={specificCurrency[id]}
                  onChange={(e) => {
                    specificCurrency[id] = e.target.value;
                    setSpecificCurrency({ ...specificCurrency });


                    setDeductibles(prev => {
                      return {
                        ...prev,
                        [id]: 'Nil Deductible'
                      };
                    });


                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    ["USD", "EURO", "GBP"].map(currency => (
                      <MenuItem key={currency} value={currency} sx={{ fontSize: 12 }}>{currency}</MenuItem>
                    ))
                  }

                </Select>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Payment Frequency</Typography>
                <Select
                  size='small'
                  value={specificPaymentFrequency[id]}
                  onChange={(e) => {
                    specificPaymentFrequency[id] = e.target.value;
                    setSpecificPaymentFrequency({ ...specificPaymentFrequency });

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    ["Annually", "Semi Annually", "Quarterly"].map(payment_frequency => (
                      <MenuItem key={payment_frequency} value={payment_frequency} sx={{ fontSize: 12 }}>{payment_frequency}</MenuItem>
                    ))
                  }

                </Select>
              </Box>

              {/* <Box sx={{ display: 'flex', alignItems: 'start' }}>
                <Typography fontSize={18} fontWeight={600} sx={{ width: 200 }}>Area of Coverage:</Typography>


                <Typography fontSize={18}>
                  <span display='inline-block' style={{ fontSize: 18, color: '#009999', fontWeight: 600 }}>{getAreaOfCoverage()}</span>
                </Typography>

              </Box> */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Inpatient Deductible</Typography>
                <CustomSelect2
                  dense
                  sx={{ minWidth: 170 }}
                  value={deductibles[id]}
                  onChange={(e) => {
                    // setDeductible(e.target.value);

                    // setDeductibleIndex(getDeductibleIndex(e.target.value));

                    const val = e.target.value;

                    const _deductibles = JSON.parse(JSON.stringify(deductibles));

                    _deductibles[id] = val;
                    // _deductibles[id].deductible_index = getDeductibleIndex(val);

                    setDeductibles(_deductibles);

                    // addToPendingTasks([id]);

                    // handleUpdateLoadingStatus(true);
                    // setLoading(true);
                    // setTimeout(() => {
                    //   ref.current.handleGetQuotation();
                    // }, 200);

                    optimumGlobalSpecific['inpatient_deductible'] = e.target.value;
                    setOptimumGlobalSpecific(optimumGlobalSpecific);

                    addToPendingTasks([id]);

                  }}
                  items={optimum_global_deductibles ? optimum_global_deductibles[specificCurrency[id]] : []}
                  disabled={loadingStatus[id]}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Outpatient Co-Pay Option</Typography>
                <CustomSelect2
                  dense
                  sx={{ minWidth: 170 }}
                  value={outpatientCoPay}
                  onChange={(e) => {
                    setOutpatientCoPay(e.target.value);

                    optimumGlobalSpecific['outpatient_co_pay'] = e.target.value;
                    setOptimumGlobalSpecific(optimumGlobalSpecific);

                    addToPendingTasks([id]);
                  }}
                  items={getOutpatientCoPayLabels()}
                  disabled={loadingStatus[id]}
                  isZeroDeductibleUniform={false}
                />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Renewal/Further Discount</Typography>
                <PercentInput
                  value={discounts[id]}
                  onCommit={(value) => setDiscounts(prev => ({ ...prev, [id]: value }))}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Renewal/Further Loading</Typography>
                <PercentInput
                  value={additionalLoadings[id]}
                  onCommit={(value) => setAdditionalLoadings(prev => ({ ...prev, [id]: value }))}
                />
              </Box>
            </Box>
          </Box>

          {/* <div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
            <Button
              size='small'
              sx={{ mb: 1 }}
              onClick={() => {
                var node = document.getElementById('table-optimum-global-rates');

                node.style = 'width: auto;';

                domtoimage.toBlob(node).then(function (blob) {
                  // Create ClipboardItem with blob and its type, and add to an array
                  const data = [new ClipboardItem({ [blob.type]: blob })];
                  // Write the data to the clipboard
                  navigator.clipboard.write(data);

                  setShowImageCopy(true);

                  node.style = 'width: 100%;';
                })
                  .catch(function (error) {
                    console.error('oops, something went wrong!', error);
                    node.style = 'width: 100%;';
                  });
              }}
              endIcon={<ContentCopyIcon />}
            >Copy Image</Button>
          </div> */}
          <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'end', width: '100%', marginBottom: 7 }}>
            <CopyExcelDataButton
              elementId='table-optimum-global-rates'
              style={{
                marginRight: 7, fontSize: 11, padding: '2px 8px', minHeight: 0
              }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
            <CopyImageButton
              elementId='table-optimum-global-rates'
              setShowImageCopy={setShowImageCopy}
              style={{ fontSize: 11, padding: '2px 8px', minHeight: 0 }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
          </div>



          <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
            <Table id='table-optimum-global-rates' size='small' sx={{ minWidth: 650, background: '#fff', width: `calc(100% + ${clients.length > 5 ? clients.length - 5 : 0} * 75px)` }}>
              <TableHead>
                {(addOns.dental || addOns.maternity || addOns.optical) &&
                  <TableRow className='row-not-included-in-excel' style={{ background: '#424242', color: '#fff' }}>
                    <TableCell colSpan={1 + (addOns.dental ? 1 : 0) + (addOns.maternity ? 1 : 0) + (addOns.optical ? 1 : 0)} style={{ color: '#fff', textAlign: 'right', fontSize: 16 }}>Add On Per Client</TableCell>

                    {/* {addOns.dental && <TableCell />}
                    {addOns.maternity && <TableCell />}
                    {addOns.optical && <TableCell />} */}

                    {
                      clients.map((client, idx) => {
                        return (
                          <TableCell key={idx}>
                            {
                              addOns.dental &&
                              <div><FormControlLabel style={{ color: '#fff' }} control={<Checkbox checked={checkAddOnPerClient('dental', idx)} onChange={() => handleAddOnPerClientChange('dental', idx)} style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, fontSize: 10 }} size="small" />} label="Dental" /></div>
                            }
                            {
                              addOns.maternity &&
                              <div><FormControlLabel style={{ color: '#fff' }} control={<Checkbox checked={checkAddOnPerClient('maternity', idx)} onChange={() => handleAddOnPerClientChange('maternity', idx)} style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, fontSize: 10 }} size="small" />} label="Maternity" /></div>
                            }
                            {
                              addOns.optical &&
                              <div><FormControlLabel style={{ color: '#fff' }} control={<Checkbox checked={checkAddOnPerClient('optical', idx)} onChange={() => handleAddOnPerClientChange('optical', idx)} style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, fontSize: 10 }} size="small" />} label="Optical" /></div>
                            }
                          </TableCell>
                        );
                      })
                    }

                    <TableCell />

                  </TableRow>
                }
                <TableRow style={{ background: '#009999', color: '#fff' }}>
                  <TableCell style={{ width: 120, color: '#fff', fontWeight: 600 }}>Plan</TableCell>

                  {
                    addOns.dental && <TableCell style={{ width: 60, color: '#fff', fontWeight: 600 }}>Dental</TableCell>
                  }

                  {
                    addOns.maternity && <TableCell style={{ width: 60, color: '#fff', fontWeight: 600 }}>Maternity</TableCell>
                  }


                  {
                    addOns.optical && <TableCell style={{ width: 60, color: '#fff', fontWeight: 600 }}>Optical</TableCell>
                  }


                  {
                    clients.map((client, idx) => {
                      if (client.full_name.trim() === '') {
                        return <TableCell style={{ width: 200, fontWeight: 600, color: '#fff' }} key={idx}>_</TableCell>
                      }

                      return <TableCell style={{ width: 200, color: '#fff', fontWeight: 600 }} key={idx}><div>{client.full_name} ({client.age})</div><div>{client.country_of_residence}</div></TableCell>
                    })
                  }
                  <TableCell style={{ color: '#fff', fontWeight: 600 }}>Subtotal</TableCell>
                </TableRow>

              </TableHead>
              <TableBody>
                <TableRatesRow
                  planId='optimum_global_emerald'
                  planName='emerald'
                  planLabel='Emerald'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeOptimumGlobalRates(response.rates) : []}
                  currency={currency}
                  additionalColumns={getAdditionalColumns('emerald')}
                  discount={discounts[id]}
                  additionalLoading={additionalLoadings[id]}
                  visible={selectedPlans.includes('optimum_global_emerald')}
                  fractionDigits={0}
                  labelWidth={190}
                />
                <TableRatesRow
                  planId='optimum_global_sapphire'
                  planName='sapphire'
                  planLabel='Sapphire'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeOptimumGlobalRates(response.rates) : []}
                  currency={currency}
                  additionalColumns={getAdditionalColumns('sapphire')}
                  discount={discounts[id]}
                  additionalLoading={additionalLoadings[id]}
                  visible={selectedPlans.includes('optimum_global_sapphire')}
                  fractionDigits={0}
                  labelWidth={190}
                />
                <TableRatesRow
                  planId='optimum_global_ruby'
                  planName='ruby'
                  planLabel='Ruby'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeOptimumGlobalRates(response.rates) : []}
                  currency={currency}
                  additionalColumns={getAdditionalColumns('ruby')}
                  discount={discounts[id]}
                  additionalLoading={additionalLoadings[id]}
                  visible={selectedPlans.includes('optimum_global_ruby')}
                  fractionDigits={0}
                  labelWidth={190}
                />
                <TableRatesRow
                  planId='optimum_global_jade'
                  planName='jade'
                  planLabel='Jade'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeOptimumGlobalRates(response.rates) : []}
                  currency={currency}
                  additionalColumns={getAdditionalColumns('jade')}
                  discount={discounts[id]}
                  additionalLoading={additionalLoadings[id]}
                  visible={selectedPlans.includes('optimum_global_jade')}
                  fractionDigits={0}
                  labelWidth={190}
                />
                <TableRatesRow
                  planId='optimum_global_diamond'
                  planName='diamond'
                  planLabel='Diamond'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeOptimumGlobalRates(response.rates) : []}
                  currency={currency}
                  additionalColumns={getAdditionalColumns('diamond')}
                  discount={discounts[id]}
                  additionalLoading={additionalLoadings[id]}
                  visible={selectedPlans.includes('optimum_global_diamond')}
                  fractionDigits={0}
                  labelWidth={190}
                />
              </TableBody>
            </Table>

          </TableContainer>

          <NotesDisplay appConfig={appConfig} insurerId={id} />

          <RatesVersionSelect
            insurer={id}
            label="Rates Version"
            insurerRates={insurerRates}
            selectedRatesVersion={selectedRatesVersion}
            setSelectedRatesVersion={setSelectedRatesVersion}
            disabled={loadingStatus[id]}
            handleFetchAppConfig={handleFetchAppConfig}
            onChange={() => setShowRefreshNow(true)}
          />

        </Box>


      </Paper>

    </Box>
  );
});

export default OptimumGlobal_Rates;